const PAGE_PREFIXES = {
  funnel: '/credit-cards/cardfinder/',
  'primary-goal': '/credit-cards/cardfinder',
  'jump-page': '/card-finder-jump',
  recommendations: '/credit-cards/cardfinder/recommendations',
} as const;

export function getPagePrefix(pageType: keyof typeof PAGE_PREFIXES) {
  return PAGE_PREFIXES[pageType];
}
